import { MatcherAnswers, StepId, getAnsweredValue } from './types';
import { SERVICES_OPTIONS } from './checkboxOptions';

// services branches per SERVICES_OPTIONS' declared order (not selection order): picking every
// option yields file, industry, entity, business, problem, plan, question in that order.
// Everything else here is fixed/unconditional.
export function buildStepQueue(answers: MatcherAnswers): StepId[] {
  const queue: StepId[] = ['location', 'services'];

  const servicesAnswer = getAnsweredValue(answers.services);
  const selectedServiceIds = Array.isArray(servicesAnswer)
    ? servicesAnswer
    : [];

  // Deduplicated: no two options' followUpSteps overlap today, but if a future option's did,
  // pushing both raw would put the same StepId in the queue twice, and MatcherReferralForm
  // renders `<StepComponent key={stepId} />` from this array - a duplicate key is a real bug,
  // not just a lint warning.
  const branchSteps: StepId[] = [];
  for (const option of SERVICES_OPTIONS) {
    if (selectedServiceIds.includes(option.id)) {
      for (const step of option.followUpSteps) {
        if (!branchSteps.includes(step)) branchSteps.push(step);
      }
    }
  }
  queue.push(...branchSteps);

  queue.push('meeting', 'search', 'name', 'phone', 'verification', 'email');

  return queue;
}

// Every Services option selected, so every branch step is included - a fan's real stepQueue is
// always a subsequence of this fixed order. MatcherStepWrapper uses it as a stable basis for the
// progress bar, instead of the fan's own stepQueue.length, which shrinks and grows as they
// answer.
export const MAX_STEP_ORDER: StepId[] = buildStepQueue({
  services: {
    status: 'answered',
    value: SERVICES_OPTIONS.map((option) => option.id)
  }
});
